export default __webpack_public_path__ + "static/6_34-58749a079a87ee19626d33cdcfd563f3.png";